import { createValue } from './functions/createValue'

export const ChartOptions = ({ state, widget }) => {
    const { percentValue, select, value, options } = state || {}
    const { max, fontColor, backgroundColor } = options || {}
    const { jsonConfig } = widget || {}
    const { type_1, type_2, text = '' } = jsonConfig || {}
    console.log('render chart options')

    return {
        chart: {
            animation: false,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            events: {
                load: function(chart) {
                    this._elements = []
                },
                redraw: function(chart) {
                    this._elements.forEach(({ rectElement }) =>
                        rectElement.map(rect => {
                            try {
                                rect.destroy()
                            } catch (error) {
                                rect == undefined
                            }
                        })
                    )
                    this._elements = []
                    createValue(this)
                    
                }
            }
        },
        title: null,
        tooltip: {
            formatter: function() {
                return `${this.point.name}: <b>${this.y}</b> `
            }
        },
        plotOptions: {
            pie: {
                shadow: false,
                center: ['50%', '50%'],
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                }
            }
        },
        series: [
            {
                name: '',
                data: [
                    {
                        name: select[0],
                        y: percentValue,
                        color: `hsla(${percentValue}, 100%, 50%, 1)`,
                        type_1,
                        type_2,
                        text,
                        max,
                        valueText: value,
                        fontColor
                    },
                    {
                        name: 'Total',
                        y: 99.9 - percentValue,
                        color: backgroundColor
                    }
                ],
                size: '100%',
                innerSize: '80%',
                dataLabels: {
                    formatter: function() {
                        return this.point.name
                    },
                    color: '#ffffff',
                    distance: 0
                }
            }
        ]
    }
}
